import { render } from "./Order.vue?vue&type=template&id=10a30c99&scoped=true"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"

import "./Order.vue?vue&type=style&index=0&id=10a30c99&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-10a30c99"

export default script